
export const GET_ANOESTRUS_LENGTH_OVERVIEW_REQUEST = "@@ddw.herdnet.sandbox.hnadvice/GET_ANOESTRUS_LENGTH_OVERVIEW_REQUEST";
export const GET_ANOESTRUS_LENGTH_OVERVIEW_SUCCESS = "@@ddw.herdnet.sandbox.hnadvice/GET_ANOESTRUS_LENGTH_OVERVIEW_SUCCESS";
export const GET_ANOESTRUS_LENGTH_OVERVIEW_FAILURE = "@@ddw.herdnet.sandbox.hnadvice/GET_ANOESTRUS_LENGTH_OVERVIEW_FAILURE";
